<header class="layout-topbar flex items-center justify-between gap-3 h-16 px-3 sm:px-4">
    <div class="flex items-center gap-2 min-w-0 self-stretch">
        <button
            type="button"
            class="layout-menu-button layout-topbar-action"
            aria-label="Toggle the menu"
            data-testid="topbar-menu-button"
            (click)="layoutService.toggleMenu()"
        >
            <i class="pi pi-bars" aria-hidden="true"></i>
        </button>

        <a class="flex min-w-0 items-center" routerLink="/" data-testid="topbar-home-link">
            <!-- The bar is dark in both themes, so the logo is the one with white letters. -->
            <img
                class="h-8 w-auto sm:h-9"
                src="images/ai-arcs-logo-white.png"
                [alt]="productName"
            />
        </a>
    </div>

    <div class="flex items-center gap-2 sm:gap-3">
        <app-theme-section />

        <!-- Beside the account menu: together they say who you are and where. -->
        <app-business-exit class="flex self-stretch" />

        <app-profile-menu />
    </div>
</header>
